module.exports = __webpack_public_path__ + "a2e95a64c99d2663ed0c58634bd8bb64.jpg";


/*****************
 ** WEBPACK FOOTER
 ** ./src/images/8.jpg
 ** module id = 218
 ** module chunks = 0
 **/